import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

function TopBar({ title, showBack = true, rightContent, onBack, position = 'sticky' }) {
  const navigate = useNavigate();

  return (
    <Box sx={{ 
      position: position, 
      top: position === 'sticky' ? 0 : 'auto', 
      bgcolor: 'transparent',
      zIndex: position === 'sticky' ? 1000 : 'auto',
      borderBottom: 1,
      borderColor: 'divider',
      width: '100%',
      maxWidth: '600px',
      margin: '0 auto'
    }}>
      <Box sx={{
        px: 2,
        py: 0.75,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1
      }}>
        <Box sx={{ display: 'inline-flex', alignItems: 'center', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
          <Box
            sx={{
              width: 'fit-content',
              display: 'inline-flex',
              minWidth: 0,
              flexGrow: 0,
              flexBasis: 'auto',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              alignItems: 'center',
            }}
          >
            {showBack && (
              <IconButton 
                onClick={onBack ? onBack : () => navigate(-1)}
                sx={{ mr: 1 }}
              >
                <ArrowBackIcon />
              </IconButton>
            )}
          </Box>
        </Box>
        {rightContent && (
          <Box
            sx={{
              width: 'auto',
              minWidth: 'fit-content',
              maxWidth: 'none',
              display: 'inline-flex',
              alignItems: 'center',
              flexShrink: 0,
              overflow: 'visible',
              whiteSpace: 'nowrap',
            }}
          >
            {rightContent}
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default TopBar; 